export default __webpack_public_path__ + "img/euxofEAt.eafd8c08.svg";